import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Col, Select, Icon, Spin, Checkbox,Input } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicButton from "../../components/frame/DynamicButton";

import ReactAbstract from "../../components/abstract/React.abstract";
import ApprovalWorkflowService from "../../services/Approval/approval-workflow-service";
import { fetchEmployeesList } from '../../actions/employee-management-actions';
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
const webConfig = require('../../config.json');

class ApprovalWorkflow extends ReactAbstract {

	dataMode = 1
	initReload = false
	moduleName = "approval"
	childModuleName = "approvalWorkflow"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {},
		data: [],
		dataStatus: "unload",
		formColumn: [],
		access: []
	}

	actions = {
		selectAction: ApprovalWorkflowService.selectApprovalWorkflow,
		createAction: ApprovalWorkflowService.createApprovalWorkflow,
		updateAction: ApprovalWorkflowService.updateApprovalWorkflow,
		deleteAction: ApprovalWorkflowService.deleteApprovalWorkflow,
	}

	headerColumn = [{
		title: "新增",
		access: "c_value",
		icon: "plus-circle-o",
		click: () => this.setState({
			currentModalStatus: true,
			currentDataStatus: "unload",
			currentIndex: null
		}, () => ApprovalWorkflowService.initiaApprovalWorkflow({}, res => {
			if (res.data.Success) {
				console.log(res)
				this.setState({
					currentDataStatus: "loaded",
					currentData: {
						document_categories: [],
						department_ids: [],
						people: []
					},
					access: [{ id: "" }],
					accessOptions: res.data.Object.basis_roles,
					formColumn: () => [{
						label: "流程名称",
						key: "approval_flow_name",
						type: "input",
						span: 24,
					
					}, {
						label: "是否启用",
						key: 'is_enabled',
						type: "checkbox",
						children: [
							{ id: true, text: "是" },
							{ id: false, text: "否" },
						],
						span: 24
					}, {
						label: "审批类型",
						key: 'document_categories',
						type: "multiSelect",
						children: res.data.Object.document_categories.map(cat => {
							return {
								id: cat.value, text: cat.text
							}
						}),
						span: 24
					}, {
						label: "应用部门",
						key: 'department_ids',
						type: "departments",
						span: 24
					}, {
						label: "角色等级",
						key: "level",
						type: "select",
						children: res.data.Object.dropdownList.map((level, index) => {
							return {
								id: index + 1,
								text: level.Text
							}
						}),
						span: 24
					}, {
						label: "抄送",
						key: "people",
						type: "people",
						required: false,
						span: 24
					}, {
						label: "备注",
						key: "remark",
						type: "textarea",
						span: 24,
						// valueWidth: "400px",
						rules: { rows: 5 }
					}
					]
				})
			} else {
				this.setState({ currentDataStatus: "error" })
			}
		}, res => this.setState({ currentDataStatus: "error" })))
	}, {
		title: "删除",
		access: "d_value",
		icon: "delete",
		click: this.publicDelete
	}
	]

	tableColumn = [{
		title: '流程名称',
		dataIndex: 'approval_flow_name',
		key: 'approval_flow_name',
		className: 'table-global-head'
	}, {
		title: '是否启用',
		dataIndex: 'is_enabled',
		key: 'is_enabled',
		className: 'table-global-head',
		render: text => text ? "是" : "否"
	}, {
		title: '备注',
		dataIndex: 'remark',
		key: 'remark',
		className: 'table-global-head'
	}, {
		title: '操作',
		dataIndex: 'actions',
		key: 'actions',
		className: 'table-global-head',
		render: (text, record, index) => (
			<DynamicButton column={this.buttonColumn(text, record, index)}
				module={this.childModuleName}
				access={this.props.access} />
		)
	}
	]

	buttonColumn = (text, record, index) => [{
		size: "small",
		type: "default",
		icon: "edit",
		title: "编辑",
		access: "u_value",
		click: () => this.setState({
			currentModalStatus: true,
			currentDataStatus: "unload",
			currentIndex: index,
			access: []
		}, () => ApprovalWorkflowService.detailApprovalWorkflow({ modelId: record.id }, res => {
			console.log(record);
			console.log(123);
			console.log(res);
			if (res.data.Success) {
				// const access = res.data.Object.details.approvalflow_basis_role_ids.map(id => {
				const access = res.data.Object.details.approvalflow_status_ids.map(id => {
					return { id: id }
				})
				this.setState({
					currentDataStatus: "loaded",
					currentData: {
						...res.data.Object.details,
						document_categories: res.data.Object.details.document_categories.map(id => {
							return { id: id + "" }
						}),
						department_ids: res.data.Object.details.department_ids.map(id => {
							return { id: id + "" }
						}),
						people: res.data.Object.details.employees.map(employee => {
							return { id: employee.value_Guid, text: employee.text }
						})
					},
					access: 0 === access.length ? [{ id: "" }] : access,
					accessOptions: res.data.Object.basis_roles,
					formColumn: () => [{
						label: "流程名称",
						key: "approval_flow_name",
						value: record.approval_flow_name,
						type: "input",
						span: 24,
					
					}, {
						label: "是否启用",
						key: 'is_enabled',
						type: "checkbox",
						children: [
							{ id: true, text: "是" },
							{ id: false, text: "否" },
						],
						span: 24
					}, {
						label: "审批类型",
						key: 'document_categories',
						type: "multiSelect",
						children: res.data.Object.document_categories.map(cat => {
							return {
								id: cat.value, text: cat.text
							}
						}),
						span: 24
					}, {
						label: "应用部门",
						key: 'department_ids',
						type: "departments",
						span: 24
					}, {
						label: "角色等级",
						key: "level",
						type: "select",
						span: 12,
						children: res.data.Object.dropdownList.map((level, index) => {
							return {
								id: index + 1,
								text: level.Text
							}
						}),
						span: 24
					}, {
						label: "抄送",
						key: "people",
						type: "people",
						required: false,
						span: 24
					}, {
						label: "备注",
						key: "remark",
						type: "textarea",
						span: 24,
						// valueWidth: "400px",
						rules: { rows: 5 }
					}
					]
				}, () => console.log(this.state))
			} else {
				this.setState({ currentDataStatus: "error" })
			}
		}, err => {
			this.setState({ currentDataStatus: "error" })
			console.log(err);
		}))
	}
	]

	customComponentWillMount() {
		this.props.fetchDepartmentsList();
	}
	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const currentData = {
					...this.state.currentData,
					...values
				}
				currentData.approvalflow_status_ids = currentData.approvalflow_basis_role_id
				const callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

	deleteApproval = index => this.setState({
		access: [
			...this.state.access.slice(0, index),
			{
				...this.state.access[index],
				deleted: true,
			},
			...this.state.access.slice(index + 1)
		]
	})

	createApproval = () => this.setState({
		access: [
			...this.state.access,
			{ id: "", text: "" }
		]
	})
	setNameFilter = name =>{
		this.setState({approval_flow_name:name});
		this.publicChange({
			approval_flow_name:name,
		}, "reload");
	}
	render() {
		let counter = 0;
		return (
			<div className="app-module-item" >
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
							<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
                        <Input.Search
                            placeholder="名称"
                            onSearch={this.setNameFilter}
                            style={{ width: 200 }}
                            enterButton />
                    </div>
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="审批流程"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					{(() => {
						switch (this.dataSource().dataStatus) {
							case "reload":
							case "loaded":
								if (!this.props.departmentStructure.departmentsList) {
									return (<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										<Spin size="large" />
									</div>)
								}
								return (
									<div style={{ height: "400px", overflow: "auto" }}>
										<DynamicForm column={this.state.formColumn}
											overflow={"hidden"}
											form={this.props.form}
											selectEmployee={this.props.fetchEmployeesList}
											employees={this.props.employeeManagement.employeeList}
											departmentsList={this.props.departmentStructure.departmentsList}
											loadStatus={this.state.currentDataStatus}
											dataSource={this.state.currentData} />
										<Form layout="inline">
											<div style={{ textAlign: "center" }}>
												{this.state.access.map((access, index) => {
													console.log(access)
													if (!access.deleted) {
														++counter;
														return (
															<Col key={index} span={24}>
																<div style={{ border: "1px #ececec solid", width: "470px", marginLeft: "auto", marginRight: "auto", marginBottom: "2px" }}>
																	<div style={{ textAlign: "center", padding: "20px" }}>第{counter}步审批流程</div>
																	<Form.Item label="审批步骤">
																		{/*{this.props.form.getFieldDecorator("approvalflow_status_ids["+(counter-1)+"]", {*/}
																		{this.props.form.getFieldDecorator("approvalflow_basis_role_id[" + (counter - 1) + "]", {
																			rules: [{ required: true, message: '请选择流程' }],
																			initialValue: access.id
																		})(
																			<Select style={{ width: "270px" }}>
																				{this.state.accessOptions.map((child) => (
																					<Select.Option key={child.id}
																						value={child.id}>{child.approvalflow_name}</Select.Option>
																				))}
																			</Select>


																		)}
																	</Form.Item>
																	<div style={{ textAlign: "center", padding: "5px" }}>
																		{counter !== 1 && <span style={{ height: "39px", lineHeight: "39px", color: "#f00", cursor: "pointer" }}
																			onClick={this.deleteApproval.bind(this, index)}><Icon type="minus-circle" /></span>}
																	</div>
																</div>
																<div style={{ width: "1px", height: "20px", background: "#ececec", margin: "0 auto" }}></div>
																<div style={{ height: "39px", lineHeight: "39px", color: "#1890ff", cursor: "pointer", textAlign: "center" }}>
																	<div onClick={this.createApproval}><Icon type="plus-circle" /></div>
																</div>
															</Col>
														)
													}
													return null
												})}
											</div>
										</Form>
									</div>
								)
							case "error":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										<Spin size="large" />
									</div>);
							default:
								return null;
						}
					})()}
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page
						}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure,
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	fetchDepartmentsList
}

ApprovalWorkflow = Form.create()(ApprovalWorkflow);

ApprovalWorkflow = connect(mapStateToProps, mapDispatchToProps)(ApprovalWorkflow);

export default LayoutWrapper(ApprovalWorkflow);




// WEBPACK FOOTER //
// ./src/routes/Approval/ApprovalWorkflow.js